module.exports = __webpack_public_path__ + "static/media/mobile_bed.3e63df0c.jpg";